import { Outlet } from 'react-router-dom'
import Sidebar from '@/components/custom/common/SideBar'
import DashboardContent from '@/components/custom/dashboard/DashboardContent'
import AssistantWidget from '@/components/custom/assistant/AssistantWidget'

export default function DashboardLayout() {
  return (
    <main className="bg-gray-100 dark:bg-slate-800 flex min-h-screen relative overflow-hidden">
      <Sidebar />
      <DashboardContent>
        <Outlet />
      </DashboardContent>
      <AssistantWidget />
    </main>
  )
}
